function updateCartCounterLaflore() {
  let url = "https://www.lafloreparis.com/cart.js";
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      updateCartDrawer(data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}

function generateCartHeaderHTML() {
  return `
    <div class="side-panel-header">
      <div>
        <span class="h6 cart-drawer__title">Cart</span>
        <side-panel-close class="side-panel-close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </side-panel-close>
      </div>
    </div>
  `;
}


function generateCartItemHTML(item, index) {
  // Форматирование цены в нужный формат

  const formatPrice = (price) => Math.round(price / 100);

  // Проверка, есть ли скидка (различаются ли цены)
  const hasDiscount = item.original_price !== item.discounted_price;

  // Формирование разметки цены
  const priceHTML = hasDiscount
    ? `<span class="price">
         <del><span class="amount"><span class="money">USD $${formatPrice(item.original_price)}</span></span></del>
         <ins><span class="amount"><span class="money">USD $${formatPrice(item.discounted_price)}</span></span></ins>
       </span>`
    : `<span class="price">
         <ins><span class="amount"><span class="money">USD $${formatPrice(item.discounted_price)}</span></span></ins>
       </span>`;

  return `
    <div class="product-cart-item product-cart-item_drawer" id="CartDrawerItem-${index}">
      <div class="product-cart-item-image product-cart-item-image_drawer">
        <img loading="lazy" class="lazyautosizes lazyloaded" width="4000" height="4000" data-sizes="auto" src="${item.image}" data-srcset="${item.image}" fetchpriority="auto" alt="${item.title}" sizes="103px" srcset="${item.image}">
        <noscript>
          <img width="4000" height="4000" sizes="auto" src="${item.image}" srcset="${item.image}" alt="${item.title}" fetchpriority="auto" loading="lazy">
        </noscript>
        <div class="loading-overlay">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
          </svg>
        </div>
      </div>
      <div class="product-cart-item-info">
        <a href="${item.url}" title="${item.product_title}" class="cart-product-link cart-drawer__item-title">${item.product_title}</a>
        <div class="product-cart-item-options product-cart-item-options_drawer">${item.variant_title}</div>
        <ul class="discounts" role="list">
          <li class="discounts__discount" style="display: ${item.discount ? 'block' : 'none'};">
            <svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="var(--color-accent)"></path>
            </svg>
            ${item.discountText}
          </li>
        </ul>
        <div style="display: flex; align-items: center; margin-top: 16px;">
          <quantity-selector style="margin-top: 0;" class="quantity cart-update small-qty buttons_added" data-id="${item.key}">
            <button class="minus ${item.quantity <= 1 ? 'disabled' : ''}" type="button" aria-label="Decrease quantity for ${item.title}">
              <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H7" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
            <input type="number" name="updates[]" id="updates_${item.key}" value="${item.quantity}" min="1" max="4504" step="1" class="qty" data-index="${index}" aria-label="Quantity for ${item.title}">
            <button class="plus" type="button" aria-label="Increase quantity for ${item.title}">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5H9" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M5 1V9" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </quantity-selector>
          <a style="display: flex; align-items: center;" href="/cart/change?line=${index}&quantity=0" class="remove" data-index="${index}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#EB4C4C"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="product-cart-item-price product-cart-item-price_drawer">
        ${priceHTML}
      </div>
    </div>
  `;
}

function generateFooter(finalPrice, originalPrice) {

  // Форматирование цен
  const formatPrice = (price) => Math.round(price / 100);

  // Проверка наличия скидки
  const hasDiscount = originalPrice !== finalPrice;

  // Формирование разметки для футера
  return `
    <div class="side-panel-footer">
      <div class="cart-drawer-footer">
        <div class="cart-drawer__border-top"></div>
        <table class="collaterals">
          <tbody>
            <tr id="cart-total-drawer" class="cart-total">
              <th style="font-family: Futura PT; font-size: 14px; font-weight: 700; line-height: 22px; text-align: left;">
                Total
                <p class="cart-policy-text">Taxes and shipping calculated at checkout</p>
              </th>
              <td>
                <span class="price">
                  ${hasDiscount ? `
                    <del><span class="money">USD $${formatPrice(originalPrice)}</span></del>
                    <ins><span class="money">USD $${formatPrice(finalPrice)}</span></ins>
                  ` : `
                    <ins><span class="money">USD $${formatPrice(finalPrice)}</span></ins>
                  `}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="cart-drawer-buttons">
          <form action="/cart" method="post" novalidate="">
            <button type="submit" class="button accent full checkout-button" name="checkout" title="Checkout">
              <span>Checkout</span>
            </button>
          </form>
          <p id="taxes-message" style="display: none"></p>
        </div>
      </div>
    </div>
  `;
}


  function updateDiscountedPrices() {
    // Get all elements with original price
    const priceElementsHor = document.querySelectorAll('.horizontal-card__price-display .money');

    // Checking if elements are found
    if (priceElementsHor.length === 0) {
      // If elements are not found, we try again in 1 second.
      setTimeout(updateDiscountedPrices, 1000);
      return;
    }

    // We iterate over all found elements
    priceElementsHor.forEach(function (priceElementHor) {
      // Get the price value from the element
      const priceTextHor = priceElementHor.textContent.trim();

      //Extracting Numeric Value from Text
      const priceHor = parseFloat(priceTextHor.replace(/[^0-9.]/g, ''));

      // We calculate the price with a 10% discount and round it up to the nearest whole number
      const discountPriceHor = Math.round(priceHor * 0.7);

      // Update the price value on the page
      priceElementHor.textContent = `USD $${discountPriceHor}`;
    });
  }

  // Run the function when the page loads
  updateDiscountedPrices();


// Обновление содержимого cart-drawer
function updateCartDrawer(cartData) {
  // Находим элемент cart-drawer
  const cartDrawer = document.getElementById('Cart-Drawer-Content');
  const countCartIcon = document.querySelector('.thb-item-count');
  if (countCartIcon) {
  countCartIcon.textContent = cartData.item_count;   
  }
 
  
  cartDrawer.innerHTML = ''; // Очистка текущего содержимого

  // Вставка внутренней панели
  cartDrawer.insertAdjacentHTML('beforeend', `
    <div class="side-panel-inner"></div>
  `);
  const sidePanelInner = cartDrawer.querySelector('.side-panel-inner');

  // Вставка заголовка корзины
  const headerHTML = generateCartHeaderHTML();
  sidePanelInner.insertAdjacentHTML('beforeend', headerHTML);

  // Вставка содержимого корзины
  sidePanelInner.insertAdjacentHTML('beforeend', `
    <div class="side-panel-content">
      <div class="product-cart-item--container"></div>
    </div>
  `);
  const itemContainer = sidePanelInner.querySelector('.product-cart-item--container');

  // Генерация элементов корзины
  cartData.items.forEach(function (item, index) {
    const itemsHTML = generateCartItemHTML(item, index + 1);
    itemContainer.insertAdjacentHTML('beforeend', itemsHTML);
  });

  const footerHTML = generateFooter(cartData.total_price, cartData.original_total_price);
  sidePanelInner.insertAdjacentHTML('beforeend', footerHTML);

  // Открытие cart-дроера и обновление счетчика
  const cartIconOpen = document.getElementById('cart-drawer-toggle');
  if (cartIconOpen) cartIconOpen.click();

}

let lastShownImageId = null;

// Function to initialize the product images on page load
function initializeProductImages() {
  // Call handleValueChange to display the correct image for the selected variant on page load
  handleValueChange();
}

// Attach the initialize function to the DOMContentLoaded event
document.addEventListener('DOMContentLoaded', initializeProductImages);

// Function to show the correct image by ID
function showImageById(imageId) {
  // Ensure all required elements are present before proceeding
  const checkboxes = document.querySelectorAll('.add-to-cart-checkbox');
  if (checkboxes.length === 0) {
    setTimeout(() => showImageById(imageId), 100); // Retry after 100 ms
    return;
  }

  if (lastShownImageId !== imageId) {
    checkboxes.forEach(checkbox => (checkbox.checked = false));
  }

  lastShownImageId = imageId; // Update the last shown imageId

  const priceWrapper = document.querySelector('.product-price-container');
  if (!priceWrapper) {
    setTimeout(() => showImageById(imageId), 100); // Retry if element is not available
    return;
  }

  const priceText = priceWrapper.querySelector('#final-price') || priceWrapper.querySelector('#final-price-precents-desktop') || priceWrapper.querySelector('#final-price-two') || priceWrapper.querySelector('#final-price-precents-desktop-two');
  const priceTextNoDiscount = priceWrapper.querySelector('.money') || priceWrapper.querySelector('.amount');
  let price = "";

  if (priceText) {
    price = priceText.textContent.match(/\d+/g).join('');
  } 
  if (!priceText) {
     price = priceTextNoDiscount.textContent.match(/\d+/g).join('');
  }
  let finalPrice = document.querySelector('#product-subtotal-price');
  if (finalPrice) {
    // Copy the price value to the finalPrice element
    finalPrice.textContent = `$${price} USD`;
  }

  // Determine selected color
const selectedColor = (document.querySelector('input[name="Color"]:checked')?.value) || 
                      (document.querySelector('input[name="Style"]:checked')?.value);

  // Iterate over all products
  document.querySelectorAll('.horizontal-product').forEach(product => {
    const images = product.querySelectorAll('.horizontal-product__image');

    // Check if there is an image for the selected color with data-inventory="true"
    const availableImage = Array.from(images).find(image => image.id === selectedColor && image.getAttribute('data-inventory') === 'true');

    if (availableImage) {
      // Show the product if the selected color is in stock
      product.style.display = 'flex';
      // Hide all images initially
      images.forEach(image => (image.style.display = 'none'));
      availableImage.style.display = 'block'; // Show the selected image
    } else {
      // If no available image for the selected color, look for a default "Black" image with data-inventory="true"
      const defaultBlackImage = Array.from(images).find(image => image.id === 'Black' && image.getAttribute('data-inventory') === 'true');
      
      if (defaultBlackImage) {
        // Show the product with the default "Black" image if available
        product.style.display = 'flex';
        // Hide all images initially
        images.forEach(image => (image.style.display = 'none'));
        defaultBlackImage.style.display = 'block'; // Show the default "Black" image
      } else {
        // If neither the selected color nor the default "Black" are available, look for a no-variant image
        const noVariantImage = Array.from(images).find(image => image.classList.contains('horizontal-product__image_no-variant'));
        
        if (noVariantImage) {
          // Show the product with the no-variant image
          product.style.display = 'flex';
          // Hide all images initially
          images.forEach(image => (image.style.display = 'none'));
          noVariantImage.style.display = 'block'; // Show the no-variant image
        } else {
          // Hide the entire product if no suitable image is available
          product.style.display = 'none';
        }
      }
    }

    // After determining the visibility of the product, check its wrapper
    const productWrapper = product.closest('#horizontal-product__wrapper');
    if (product.style.display === 'none') {
      // Hide the wrapper if the product is hidden
      if (productWrapper) {
        productWrapper.style.display = 'none';
      }
    } else {
      // Show the wrapper if the product is visible
      if (productWrapper) {
        productWrapper.style.display = 'flex';
      }
    }
  });
}


// Find the element with the class 'product'
const productElement = document.querySelector('.product');


// Find the element with the class 'variant-picker__option-info' inside 'product'
const variantPickerOptionInfo = productElement.querySelector('variant-selects');


// Find the 'variant-option-value' tag inside 'variant-picker__option-info'

const variantOptionValue = variantPickerOptionInfo.querySelector('.form__label__value');  



// Array with products to be added to the cart
let productsToAdd = [];


// Call handleValueChange to initialize images based on the current variant selection
function handleValueChange() {
  const variantOptionValue = document.querySelector('.form__label__value');
  if (!variantOptionValue) {
    setTimeout(handleValueChange, 100); // Retry after 100 ms if element not available
    return;
  }

  const textValue = variantOptionValue.textContent;
  setTimeout(() => {
    showImageById(textValue); 
  }, 1000); 
  
  // Clear the productsToAdd array when the product variant changes
  productsToAdd = [];

  // Update the productsToAdd array to change the product ids if the product variant changes
  const checkboxes = document.querySelectorAll('.add-to-cart-checkbox');
  checkboxes.forEach(checkbox => {
    if (checkbox.checked) {
      const newId = parseInt(getCheckboxImageAltId(checkbox), 10);
      const productIndex = productsToAdd.findIndex(product => product.id === newId);
      if (productIndex === -1) {
        updateProductsToAdd(newId, 1, true);
      }
    }
  });

}


// Create a MutationObserver to monitor changes
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      handleValueChange();
    }
  }
});

// Observer configuration
const config = {
  characterData: true,
  childList: true,
  subtree: true
};

// Start observing the 'variant-option-value' element
observer.observe(variantOptionValue, config);


// Function to update the productsToAdd array
function updateProductsToAdd(id, quantity, add) {
  const productIndex = productsToAdd.findIndex(product => product.id === id);

  if (add) {
    if (productIndex === -1) {
      productsToAdd.push({ id, quantity });
    }
  } else {
    if (productIndex !== -1) {
      productsToAdd.splice(productIndex, 1);
    }
  }
}

function monitorCheckboxes() {
  const checkboxes = document.querySelectorAll('.add-to-cart-checkbox');

  if (checkboxes.length === 0) {
    setTimeout(monitorCheckboxes, 1000); // Retry if no checkboxes found
    return;
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const id = parseInt(getCheckboxImageAltId(checkbox), 10);
      const add = checkbox.checked;

      updateProductsToAdd(id, 1, add); // Update products array
      updateSubtotal(checkbox, add);   // Update subtotal correctly

      // Ensure the subtotal doesn't reset
      setTimeout(() => {
        document.querySelector('.product__subtotal-price').textContent = `$${currentSubtotal} USD`;
      }, 100);
    });
  });
}


function getCheckboxImageAltId(checkbox) {
  // Find the image associated with the current checkbox
  const productCard = checkbox.closest('.horizontal-product');
  const visibleImageWithoutVariants = productCard.querySelector('.horizontal-product__image_no-variant');
  if (visibleImageWithoutVariants) {
    return visibleImageWithoutVariants.getAttribute('alt');
  } else {
     const visibleImage = productCard.querySelector('.horizontal-product__image[style*="display: block"]');
     return visibleImage.getAttribute('alt'); 
  }
}

let currentSubtotal = 0; // Persistent state to keep track of the subtotal

function updateSubtotal(checkbox, add) {
  const subtotalElement = document.querySelector('.product__subtotal-price');

  if (!subtotalElement) return;

  // Extracting the current displayed subtotal
  const match = subtotalElement.textContent.match(/\d+/);
  let displayedSubtotal = parseInt(match ? match[0] : currentSubtotal);

  // Fetching the price related to the checkbox
  const priceElement = checkbox.closest('.horizontal-card__input-wrapper').querySelector('.horizontal-card__price-display');
  const priceText = priceElement ? priceElement.textContent.trim() : '';
  const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));

  // Adjust subtotal based on whether the checkbox was checked or unchecked
  if (add) {
    console.log(price, "price")
    displayedSubtotal += price;
  } else {
    console.log(price, "price")
    displayedSubtotal -= price;
  }

  // Update both the DOM and the persistent state
  currentSubtotal = displayedSubtotal;
  subtotalElement.textContent = `$${currentSubtotal} USD`;
}


monitorCheckboxes();


function observePriceChanges() {
  const priceElement = document.querySelector('#final-price-precents-desktop'); // Первый возможный элемент
  const amountElement = document.querySelector('.amount'); // Второй возможный элемент
  const subtotalElement = document.querySelector('#product-subtotal-price'); // Элемент для обновления

  if (!subtotalElement) {
    return; // Выходим, если элемент для обновления не найден
  }

  // Функция для обновления subtotal на основе элемента с ценой
  const updateSubtotal = (element) => {
    console.log(element, "priceElement")
    const priceText = element.textContent.trim();
    const priceMatch = priceText.match(/\d+/g); // Извлекаем число из строки

    if (priceMatch) {
      let price = priceMatch.join('');
      subtotalElement.textContent = `$${price} USD`; // Обновляем итоговую сумму
    }
  };

  // Создаем функцию для установки наблюдателя
  const setObserver = (element) => {
    if (!element) return; // Если элемента нет, выходим

    // Создаем MutationObserver для отслеживания изменений в элементе
const observer = new MutationObserver(() => {
  setTimeout(() => {
    updateSubtotal(element); // Обновляем subtotal при изменении элемента с задержкой
  }, 1000); // Задержка в 1000 мс (1 секунда)
});

    // Отслеживаем изменения в элементе
    observer.observe(element, { characterData: true, childList: true, subtree: true });
  };

  // Устанавливаем наблюдатель на каждый из возможных элементов
  setObserver(priceElement);
  setObserver(amountElement);
}

// Инициализация наблюдателя при загрузке страницы
document.addEventListener('DOMContentLoaded', () => {
  initializeProductImages(); // Если требуется
  observePriceChanges(); // Начинаем отслеживать изменения цены
});


const url = "https://www.lafloreparis.com/cart/add.js";

const addToCartButtonAddon = document.getElementById('AddToCartAddons');
const addToCartButton = document.getElementById('AddToCart');

let isProcessing = false;

addToCartButtonAddon.addEventListener('click', function (event) {
  if (isProcessing) return; // Блокируем повторные клики
  isProcessing = true;

  event.preventDefault();
  // Проверяем, что productsToAdd существует и не пустой
  if (!Array.isArray(productsToAdd) || productsToAdd.length === 0) {
    console.warn('No products to add. Skipping fetch request.');
    setTimeout(() => {
      addToCartButton.click();
      isProcessing = false; // Сбрасываем флаг после клика
    }, 1000); // Задержка в 1 секунду
    return;
  }

  // Формируем данные для запроса
  const formData = {
    items: productsToAdd
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      isProcessing = false; // Сбрасываем флаг после завершения
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(errorData.message || 'Произошла неизвестная ошибка');
        });
      }
      return response.json();
    })
    .then(data => {
      updateCartCounterLaflore();
      hideErrorMessage();
    })
    .catch(error => {
      isProcessing = false; // Сбрасываем флаг после ошибки
      console.error('Error adding products to cart:', error);
      showErrorMessage(error.message);
    });

  // Имитируем клик по основной кнопке после задержки
  setTimeout(() => {
    addToCartButton.click();
  }, 1000);
});
function showErrorMessage(message) {
  // Find the error container
  const errorContainer = document.querySelector('.form-notification.error');
  
  if (errorContainer) {
    errorContainer.textContent = message;
    errorContainer.style.display = 'block';
  }
}

function hideErrorMessage() {
  const errorContainer = document.querySelector('.form-notification.error');
  
  if (errorContainer) {
    errorContainer.style.display = 'none';
    errorContainer.textContent = '';
  }
}


  const priceData = [];

    document.querySelectorAll('.price-metafields-wrapper').forEach(price => {
    const variantTitle = price.querySelector('.variant-meta-title-price')?.textContent.trim();
    const originalPrice = price.querySelector('.variant-original-price-meta')?.textContent.trim();
    const fakePrice = price.querySelector('.variant-fake-price-meta')?.textContent.trim();
    priceData.push({ variantTitle, originalPrice, fakePrice });
  });


function updatePriceState(attempts = 20) {
  const selectedVariant = document
    .querySelector(".form__label__value")
    ?.textContent.trim();

  if (!selectedVariant) {
    console.warn("⚠ Нет данных о варианте!");
    return;
  }

  console.log(`🔍 Выбран вариант: ${selectedVariant}`);

  const variantInfo = priceData.find(
    (variant) =>
      variant.variantTitle.toLowerCase() === selectedVariant.toLowerCase()
  );

  const naturalPrice = document.querySelector(".product-information .price .amount .money");
  const fakePriceWrapper = document.querySelector(".price-metafields-wrapper");
  const fakePrice = document.querySelector('.variant-fake-price-meta');
  const originalFakePrice = document.querySelector('.variant-original-price-meta');
  const priceContainer = document.querySelector(".product-price-container__wrapper");
  const subTotalPrice = document.querySelector("#product-subtotal-price");

  if (!naturalPrice) {return}

  if (!priceContainer) {
    console.error("❌ Элемент .product-price-container не найден!");
    return;
  }
 
  if (!subTotalPrice) {
    if (attempts > 0) {
      console.log(`⏳ Ждем subTotalPrice... Осталось попыток: ${attempts}`);
      setTimeout(() => updatePriceState(attempts - 1), 300); // Повторяем через 300 мс
    } else {
      console.error("❌ subTotalPrice не найден после нескольких попыток!");
    }
    return;
  }

  setTimeout(() => {
    if (!variantInfo) {
      console.log("❌ Вариант не найден, показываем обычную цену.");
      naturalPrice.style.display = "block";
      fakePriceWrapper.style.display = "none";
    } else {
      console.log("✅ Вариант найден, показываем фейковую цену.");
      naturalPrice.style.display = "none";
      fakePriceWrapper.style.display = "block";
      originalFakePrice.textContent = variantInfo.originalPrice;
      fakePrice.textContent = variantInfo.fakePrice;

      const formattedPrice = `$${parseFloat(variantInfo.fakePrice.replace(/[^\d.]/g, ""))} USD`;
      subTotalPrice.textContent = formattedPrice;
      console.log(`💰 Обновили сабтотал: ${formattedPrice}`);
    }

    console.log("🔼 Показываем контейнер");
    priceContainer.style.opacity = "1";
  }, 1500);
}

// 🔥 Автообновление при изменении варианта
function observeVariantChange() {
  const targetNode = document.querySelector(".form__label__value");

  if (!targetNode) {
    console.error("❌ Элемент .form__label__value не найден!");
    return;
  }

  let timeout;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          console.log("🔄 Обнаружено изменение варианта, обновляем цену...");
          updatePriceState();
        }, 1500);
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });

  console.log("👀 Наблюдение за изменением варианта запущено.");
}

// 🚀 Инициализация
document.addEventListener("DOMContentLoaded", () => {
  console.log("🔧 Инициализация скрипта");
  observeVariantChange();
  updatePriceState();
});